/**
 * product-quick-view.js — one modal, section HTML from /products/{handle}?sections=product-quick-view
 */
(function () {
  'use strict';

  const MODAL_ID = 'product-quick-view-modal';
  const INNER_SEL = '[data-quick-view-inner]';
  const LOADING_SEL = '[data-quick-view-loading]';
  const TRIGGER_SEL = '[data-quick-view-trigger]';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function setLoading(modal, on) {
    const el = modal.querySelector(LOADING_SEL);
    if (!el) return;
    el.hidden = !on;
    el.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  function openModal(modal) {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.hidden = true;
    const inner = modal.querySelector(INNER_SEL);
    if (inner) inner.innerHTML = '';
    document.body.style.overflow = '';
  }

  async function loadProductSection(productPath) {
    const path = new URL(productPath, window.location.origin).pathname;
    if (typeof fetchSection !== 'function') {
      throw new Error('fetchSection is not available (load utils.js before product-quick-view.js)');
    }
    const data = await fetchSection(path, ['product-quick-view']);
    const html = data['product-quick-view'];
    if (!html) throw new Error('Missing product-quick-view section');
    return html;
  }

  function injectSectionHtml(inner, htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const sectionEl = doc.querySelector('[id^="shopify-section-"]');
    if (!sectionEl) {
      inner.innerHTML = htmlString;
      return;
    }
    inner.innerHTML = sectionEl.innerHTML;
  }

  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest(TRIGGER_SEL);
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();

    const productUrl = trigger.dataset.productUrl;
    if (!productUrl) return;

    const modal = getModal();
    if (!modal) return;

    const inner = modal.querySelector(INNER_SEL);
    if (!inner) return;

    openModal(modal);
    setLoading(modal, true);
    inner.innerHTML = '';

    try {
      const html = await loadProductSection(productUrl);
      injectSectionHtml(inner, html);
      const focusTarget =
        inner.querySelector('button[type="submit"], [href], input') || inner;
      if (focusTarget.focus) focusTarget.focus();
    } catch (err) {
      console.error(err);
      inner.innerHTML =
        '<p class="body-md" role="alert">Unable to load product. Please try again.</p>';
    } finally {
      setLoading(modal, false);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-quick-view-close]')) {
      const modal = getModal();
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = getModal();
    if (!modal || modal.hidden) return;
    closeModal(modal);
  });
})();
